module.exports = __webpack_public_path__ + "static/img/head-en.c253c700.png";